import React from 'react';
import PropTypes from 'prop-types';
import SimpleTicketsToBreakevenCard from './SimpleTicketsToBreakevenCard';
import SimpleBudgetSummaryCard from './SimpleBudgetSummaryCard';
import SimpleFinancialSummaryCard from './SimpleFinancialSummaryCard';

const SimpleOfferRail = ({ ctrl, collapsed, onToggle }) => {
  if (collapsed) {
    return (
      <aside className="simple-offer-rail simple-offer-rail--collapsed">
        <button
          className="simple-offer-rail__toggle"
          aria-label="Expand summary panel"
          aria-expanded={false}
          onClick={onToggle}
        >
          <i className="fas fa-chevron-left" />
        </button>
        <span className="simple-offer-rail__collapsed-label">SHOW SUMMARY</span>
      </aside>
    );
  }

  return (
    <aside className="simple-offer-rail">
      <div className="simple-offer-rail__header">
        <button
          className="simple-offer-rail__toggle"
          aria-label="Collapse summary panel"
          aria-expanded={true}
          onClick={onToggle}
        >
          <i className="fas fa-chevron-right" />
        </button>
      </div>
      <SimpleTicketsToBreakevenCard ctrl={ctrl} />
      <SimpleBudgetSummaryCard ctrl={ctrl} />
      <SimpleFinancialSummaryCard ctrl={ctrl} />
    </aside>
  );
};

SimpleOfferRail.propTypes = {
  ctrl: PropTypes.object.isRequired,
  collapsed: PropTypes.bool,
  onToggle: PropTypes.func.isRequired,
};

SimpleOfferRail.defaultProps = {
  collapsed: false,
};

export default SimpleOfferRail;
